// import { Input } from './input.component';
// import { DefaultButton } from './defaultButton.component';
import { AppliedFilter } from './appliedFilter.component';

export default {
  // Input,
  // DefaultButton,
  AppliedFilter
};
